import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const BATCHES_LOAD = 'BATCHES/BATCHES_LOAD';
export const BATCHES_SUCCESS = 'BATCHES/BATCHES_SUCCESS';
export const BATCHES_FAILURE = 'BATCHES/BATCHES_FAILURE';

export const fetchUrl = `${config.batchApiUrl}/batches`; // update emvio config batch url and swap this out

export function getBatches(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'closeDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getBatchesFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: BATCHES_LOAD,
        successActionTypeOrCreator: getBatchesSuccessActionCreator
    };
}

export function getBatchesSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, BATCHES_SUCCESS, 'batches');
}

export function getBatchesFailureActionCreator(error) {
    return {
        error,
        type: BATCHES_FAILURE
    };
}
